module.exports = __webpack_public_path__ + "static/media/manitoba_flag.20434dc5.svg";